module.exports = (theme) => ({
  ".error": {
    display: "block",
  },
  ".error.is-error, .error.is-warning, .error.is-waiting": {
    position: "relative",
    overflow: "hidden",
  },
  ".error.is-error::before, .error.is-warning::before, .error.is-waiting::before": {
    content: "''",
    position: "absolute",
    background: theme("colors.primary.white"),
    color: theme("colors.primary.black.DEFAULT"),
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    margin: 0,
    zIndex: theme("zIndex.10"),
  },
  ".error .error-message": {
    display: "none",
  },
  ".error.is-error .error-message, .error.is-warning .error-message, .error.is-waiting .error-message": {
    display: "block",
    position: "absolute",
    background: theme("colors.primary.white"),
    left: "50%",
    top: "50%",
    zIndex: theme("zIndex.10"),
    transform: "translate(-50%, -50%)",
    textAlign: "center",
  },
  ".error.is-error .error-message::before, .error.is-warning .error-message::before, .error.is-waiting .error-message::before": {
    fontFamily: theme("fontFamily.icons"),
    marginBottom: theme("spacing.2xs"),
    display: "block",
    fontSize: theme("fontSize.6xl"),
    lineHeight: theme("fontSize.6xl"),
  },
  ".error.is-error::after, .error.is-warning::after, .error.is-waiting::after": {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
    fontFamily: theme("fontFamily.icons"),
    fontSize: theme("fontSize.6xl"),
    lineHeight: theme("fontSize.6xl"),
  },
  ".error.is-error::after, .error.is-error .error-message::before": {
    content: "'\\e9d7'",
  },
  ".error.is-warning::after, .error.is-warning .error-message::before": {
    content: "'\\ea78'",
  },
  ".error.is-waiting::after, .error.is-waiting .error-message::before": {
    content: "'\\e9f9'",
  },
});
